<template>
    <div class="locale-changer">
        <button @click="select('de')" :class="{'local-active': $i18n.locale === 'de'}">
            <svg  xmlns="http://www.w3.org/2000/svg" id="flag-icons-de" viewBox="0 0 640 480">
                <path fill="#ffce00" d="M0 320h640v160H0z"/>
                <path d="M0 0h640v160H0z"/>
                <path fill="#d00" d="M0 160h640v160H0z"/>
            </svg>
        </button>
        <button @click="select('en')" :class="{'local-active': $i18n.locale === 'en'}">
            <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-gb" viewBox="0 0 640 480">
                <path fill="#012169" d="M0 0h640v480H0z"/>
                <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"/>
                <path fill="#C8102E" d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"/>
                <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z"/>
                <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"/>
            </svg>
        </button>
    </div>
</template>

<script>

import Vue from "vue";
export default {
    name: 'locale-changer',
    data () {
        return { 
            langs: ['en', 'de']
        }
    },
    methods: {
        select(lang) {
            if(lang === this.$i18n.locale) {
                return;
            }
            this.$i18n.locale = lang;
            
            this.$router.push('/' + lang + '/' + Vue.getRouteConfig(this.$route.name).paths[lang]);
            this.$router.go()
        },
    }
}
</script>

<style scoped="scoped">
.locale-changer {
    line-height: 2em;
    width:4em;
}
.locale-changer svg {
    width:1.4em;
    margin-left:.3em;
    border-radius: 5px;
    background-color: var(--v-primary-base);
    border: 2px solid var(--v-primary-base);
}
.locale-changer svg:first-child {
    margin-right:0.1em;
}
.locale-changer button {
    opacity: 0.5;
}
.locale-changer button.local-active {
    opacity: 1;
}
</style>